import type { CoinType } from '../cointype/CoinTypeStore';
import type { GameLabel } from '../game/types';
import type { BundleItem } from '../rewards/types';

export enum MissionTypeEnum {
  SPIN_X_TIMES = 'SPIN_X_TIMES',
  BET_SUM_OF = 'BET_SUM_OF',
  WIN_SUM_OF = 'WIN_SUM_OF',
  WIN_FREE_SPINS = 'WIN_FREE_SPINS',
  WIN_A_BIG_WIN = 'WIN_A_BIG_WIN',
  WIN_A_JACKPOT = 'WIN_A_JACKPOT',
  WIN_X_TIMES_IN_A_ROW = 'WIN_X_TIMES_IN_A_ROW',
  WIN_X_TIMES = 'WIN_X_TIMES',
  WIN_X_IN_ONE_SPIN = 'WIN_X_IN_ONE_SPIN',
}

export const MissionsWithIntegerProgress = [
  MissionTypeEnum.SPIN_X_TIMES,
  MissionTypeEnum.WIN_FREE_SPINS,
  MissionTypeEnum.WIN_X_TIMES_IN_A_ROW,
  MissionTypeEnum.WIN_X_TIMES,
];

export type PackageBundlesData = {
  packageId: number;
  gcCoin: number;
  scCoin: number;
  price: number;
  bundleItems: BundleItem[];
};

export type DailyMissionStatus = 'ACTIVE' | 'COMPLETED' | 'UPCOMING' | 'CLAIMED_REWARD';

export interface PackageData {
  scCoin: number;
  gcCoin: number;
  amount: number;
  packageId: number;
  bundleItems: BundleItem[];
}

export interface DailyMission {
  id: string;
  order: number;
  goal: number;
  missionType: MissionTypeEnum;
  missionConfiguration: any;
  gameId: number;
  startDate: string;
  endDate: string;
  rewardId: number;
  coinType: CoinType;
  userId: string;
  packageData: PackageData;
}

export type GrandPrizeReward = {
  id: string;
  startDate: string;
  endDate: string;
  rewardId: number;
  coinType: CoinType;
  packageData: PackageData;
};

export interface UserDailyMission extends DailyMission {
  progress: number;
  status: DailyMissionStatus;
  dailyMissionId: string;
  userId: string; // firebase
  timeLeft: number;
  gameImageUrl: string;
  gameName?: string;
}

export type DailyMissionsResponse = {
  scMissions: UserDailyMission[];
  gcMissions: UserDailyMission[];
  scRewards: UserDailyMission[];
  gcRewards: UserDailyMission[];
  scGrandPrize: GrandPrizeReward | null;
  gcGrandPrize: GrandPrizeReward | null;
  scGrandPrizesRewards: GrandPrizeReward[];
  gcGrandPrizesRewards: GrandPrizeReward[];
  gameLabel: GameLabel | null;
};
